import { render, staticRenderFns } from "./TemplateVariableModal.vue?vue&type=template&id=4daa4a38&scoped=true&"
import script from "./TemplateVariableModal.vue?vue&type=script&lang=js&"
export * from "./TemplateVariableModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daa4a38",
  null
  
)

export default component.exports